@if (!listaFolders.length && aziendaFolder) {
  <button
    mat-stroked-button
    color="primary"
    class="add-document-btn"
    (click)="nuovoFolder(aziendaFolder, true)"
  >
    <mat-icon>add</mat-icon>
    Crea Cartella
  </button>
} @else {
  <div class="cnt-tree-file">
    <mat-tree #tree [dataSource]="listaFolders" [childrenAccessor]="childrenAccessor">
      <mat-tree-node
        *matTreeNodeDef="let folder; when: hasSottoCartelle"
        matTreeNodePadding
        [matTreeNodePaddingIndent]="12"
      >
        <div
          (dblclick)="expandCollapseFolder(folder)"
          (click)="onFolderClick(folder)"
          class="cnt-tree-node"
          [class.selected]="isSelected(folder)"
          style="cursor: pointer"
        >
          <!-- EXPAND ICON  -->
          <mat-icon
            class="arrow-icon"
            (click)="
              expandCollapseFolder(folder); $event.stopPropagation(); $event.preventDefault()
            "
            [ngStyle]="{ color: hasSottoCartelle(folder) ? '#1f1f1f' : 'transparent' }"
          >
            {{ tree.isExpanded(folder) ? 'arrow_drop_down' : 'arrow_right' }}
          </mat-icon>
          <!-- FOLDER ICON + NOME FOLDER -->
          <div class="cnt-icon-nome-folder">
            <mat-icon>
              {{ folderIcon(folder) }}
            </mat-icon>
            <span
              class="nome-folder"
              [ngClass]="isHomeFolder(folder.id) ? 'nome-folder home' : 'nome-folder'"
            >
              {{ folder.name }}
            </span>
          </div>
          <!-- MENU FOLDER ON HOVER-->
          <div class="menu-btn">
            <app-menu-folder
              [isFolder]="true"
              [folderSelezionato]="folder"
              (folderCreatoEvent)="folderCreato($event, folder)"
            ></app-menu-folder>
          </div>
        </div>
      </mat-tree-node>
    </mat-tree>
  </div>
}
